import React from 'react';
import { EXPERIMENTS } from '../../../constants';
import { useExperiments } from '../../../contexts/experiments-context';
import { getHeaderAndParagraphCustomStylesWUT, getHeaderVariantCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
import { ToggleTruncateButtonWUT } from '../../../ui/ricos-viewer/toggle-truncate-button-wut';
import { useTruncateRicosContent } from '../../../ui/ricos-viewer/use-truncate-ricos-content';
export const HeaderWUT = ({ content, maxShownParagraphs, id, FieldLayout })=>{
    const { isExperimentEnabled } = useExperiments();
    const isHeadingLevelsEnabled = isExperimentEnabled(EXPERIMENTS.ENABLE_HEADING_LEVELS);
    const customStyles = React.useMemo(()=>isHeadingLevelsEnabled ? {
            ...getHeaderAndParagraphCustomStylesWUT(),
            ...getHeaderVariantCustomStylesWUT()
        } : getHeaderAndParagraphCustomStylesWUT(), [
        isHeadingLevelsEnabled
    ]);
    const customTheme = useRicosTheme({
        customStyles
    });
    const { displayedContent, isTruncated, isTruncateButtonShown, toggleTruncate } = useTruncateRicosContent(content, maxShownParagraphs);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id
    }, /*#__PURE__*/ React.createElement(RicosViewer, {
        content: displayedContent,
        customTheme: customTheme
    }), isTruncateButtonShown && /*#__PURE__*/ React.createElement(ToggleTruncateButtonWUT, {
        isTruncated: isTruncated,
        onClick: toggleTruncate
    }));
};

//# sourceMappingURL=header-wut.js.map